enum OrganisationTypeEnum {
    PhysicalPerson = 'Physical_person',
    LegalPerson = 'Legal_person',
    SeparateSubdivision = 'Separate_subdivision',
}

export default OrganisationTypeEnum;
